// import React from 'react';
import { useState } from 'react';
import Navbar from '../../components/navbar/Navbar';
import Sidebar from '../../components/navbar/Sidebar';
import Footer from '../../components/footer/Footer'; 
import TeachersAndStaffBody from '../../components/internal/AboutUs/TeachersAndStaff/TeachersAndStaffBody';

function TeachersAndStaff() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  return (
    <>
      <Navbar toggleSidebar={toggleSidebar} />
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <TeachersAndStaffBody />
      <Footer />
    </>
  );
}

export default TeachersAndStaff;